<script>
  import { createEventDispatcher } from "svelte";
  import { sortStore, currentViewStore } from "./stores.js";
  import { VOCABULARY } from "./constants.js";
  const dispatch = createEventDispatcher();
  let currentView = VOCABULARY;

  function handleClick(event) {
    const newSection = event.target.textContent.toLowerCase();
    if (newSection !== "recently started") currentViewStore.set(VOCABULARY);
    sortStore.set(newSection);
  }
</script>

<style>
  .sort {
    align-items: center;
    background: var(--purple-banner);
    border-radius: 8px;
    box-shadow: var(--card-box-shadow);
    display: flex;
    padding: 1rem 1.5rem;
    margin-bottom: 2.5rem;
    transition: all 0.3s;
  }

  .sort.radicals {
    background: var(--blue-banner);
  }

  .sort.kanji {
    background: var(--pink-banner);
  }

  .controls {
    align-items: center;
    display: flex;
    margin-left: 1.5rem;
  }

  button {
    border: none;
    background: none;
    padding: 0;
    border-right: 1px solid #aaa;
    margin: 0;
    margin-right: 1rem;
    padding-right: 1rem;
    color: blue;
    cursor: pointer;
  }

  button:last-child {
    border-right: none;
    margin-right: 0;
  }

  button.active {
    color: var(--black);
    font-weight: 700;
    cursor: default;
  }

  @media screen and (max-width: 768px) {
    .sort {
      flex-direction: column;
      padding: 1rem 0;
    }

    .controls {
      margin-top: 1rem;
      margin-left: 0;
    }

    button {
      flex: 1;
      margin-right: 0;
      padding: 0 1rem;
    }
  }
</style>

<div id="sort" class={`sort ${$currentViewStore}`}>
  <span>Sort by:</span>
  <div class="controls">
    <button
      class:active={$sortStore === 'recently started'}
      on:click={e => handleClick(e)}>
      Recently Started
    </button>
    <button
      class:active={$sortStore === 'frequently missed'}
      on:click={e => handleClick(e)}>
      Frequently Missed
    </button>
    <button
      class:active={$sortStore === 'random'}
      on:click={e => handleClick(e)}>
      Random
    </button>
  </div>
</div>
